
//#region ENUM LocaleDateFormatEnum
export enum LocaleDateFormatEnum {
  MEDIUM = 'MEDIUM',
  LONG = 'LONG',
  FULL = 'FULL',
  DEFAULT = 'DEFAULT',
  WEEKDAY_MONTH_DAY_YEAR = 'WEEKDAY_MONTH_DAY_YEAR',
  DATETIME_MEDIUM = 'DATETIME_MEDIUM',
  DATETIME_LONG = 'DATETIME_LONG',
  FULL_DATETIME = 'FULL_DATETIME',
  NUMERIC_MONTH_DAY_YEAR = 'NUMERIC_MONTH_DAY_YEAR',
  TIME_SHORT = 'TIME_SHORT',
}
//#endregion
